import React from 'react';
import SEO from '@/components/SEO';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import Hero from '@/components/Hero';
import IntroSection from '@/components/talk-to-your-data/IntroSection';
import HowItWorksSection from '@/components/talk-to-your-data/HowItWorksSection';
import PlatformsSection from '@/components/talk-to-your-data/PlatformsSection';
import BenefitsSection from '@/components/talk-to-your-data/BenefitsSection';
import { useLanguage } from '@/contexts/language/LanguageContext';

const TalkToYourData = () => {
  const { t } = useLanguage();
  
  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title="Talk to Your Data | Stratodata"
        description="Query your retail data in plain language. Our AI-powered interface lets your team ask questions and get answers from live data — no SQL needed."
        canonical="/talk-to-your-data"
      />
      <Navigation />
      
      <Hero 
        title={t('interactNatural')}
        subtitle={t('interactDesc')}
        ctaText={t('getStarted')}
        ctaLink="/tell-me-more"
        showSwitchingText={false}
      />
      
      <IntroSection />
      <HowItWorksSection />
      <PlatformsSection />
      <BenefitsSection />

      <Footer />
    </div>
  );
};

export default TalkToYourData;
